import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clear-pending-messages"
export default class extends Controller {
  connect() {
    // Remove any existing pending messages when a new message is rendered
    this.removePendingMessages()
  }

  removePendingMessages() {
    // Find all messages with data-pending="true"
    const pendingMessages = document.querySelectorAll('[data-pending]')

    pendingMessages.forEach(message => {
      message.remove()
    })
  }
}
